const _excluded = ["onClick", "loading", "variant", "disabled", "icon", "text"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Button } from './Button';
import { useTranslation } from 'react-i18next';
export function AddButton(_ref) {
  let {
      onClick,
      loading,
      variant = 'info',
      disabled = false,
      icon = null,
      text = null
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: variant,
    disabled: disabled,
    loading: loading,
    onClick: onClick,
    icon: icon || 'add'
  }, props), text ? t(text) : t('add'));
}
;